module.exports = __webpack_public_path__ + "static/media/interactive-video.233a4616.svg";